import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { to: "/hub", label: "Planning Hub", testid: "nav-link-hub" },
  { to: "/rural", label: "Rural Land", testid: "nav-link-rural" },
  { to: "/start/commercial", label: "Commercial", testid: "nav-link-commercial" },
  { to: "/da-approved", label: "After Your DA", testid: "nav-link-da-approved" },
  { to: "/toolkits", label: "Toolkits", testid: "nav-link-toolkits" },
  { to: "/services", label: "Services", testid: "nav-link-services" },
  { to: "/about", label: "About", testid: "nav-link-about" },
  { to: "/insights", label: "Insights", testid: "nav-link-insights" },
  { to: "/contact", label: "Contact", testid: "nav-link-contact" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-ivory/90 backdrop-blur-md border-b border-cloud">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" data-testid="nav-link-home" aria-label="PLAN FIRST NSW home">
            <Logo />
          </Link>
          <nav className="hidden lg:flex items-center gap-8">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={l.testid}
                className={`text-sm tracking-wide transition-colors duration-300 ${
                  pathname.startsWith(l.to)
                    ? "text-teal font-semibold"
                    : "text-charcoal/70 hover:text-teal"
                }`}
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <Link
              to="/book"
              data-testid="nav-link-booking"
              className="hidden sm:inline-flex items-center gap-2 bg-teal text-ivory text-sm font-medium px-5 py-2.5 rounded-full hover:bg-teal-dark transition-colors duration-300"
            >
              Planner Connect
              <span className="text-[9px] font-mono uppercase tracking-[0.12em] bg-sand text-teal px-1.5 py-0.5 rounded-full">Soon</span>
            </Link>
            <button
              className="lg:hidden p-2 text-teal"
              onClick={() => setOpen(!open)}
              data-testid="mobile-menu-button"
              aria-label="Toggle menu"
            >
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-cloud bg-ivory" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="font-serif text-2xl text-teal"
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/book"
              onClick={() => setOpen(false)}
              className="inline-flex w-fit items-center gap-2 bg-teal text-ivory text-sm font-medium px-5 py-3 rounded-full"
            >
              Planner Connect
              <span className="text-[9px] font-mono uppercase tracking-[0.12em] bg-sand text-teal px-1.5 py-0.5 rounded-full">Soon</span>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
